export default {
  gGet: (state, getters, rootState) => (id) => {
    return state.layouts.find(layout => layout.id === id);
  },
  gFindGridById: (state, getters, rootState) => (id) => {
    return state.layout.grids.find(grid => grid.id === id);
  }
}
